import PharmacySearchV2ViewController from "./pharmacy-search-v2-view-controller";
import { searchButtons, manualPharmacyFormState } from "./helpers/pharmacy";
import { clearPreBuiltFields } from "./helpers/template-fields";
import {
  getFieldActionEventStates,
  actionEventsMap
} from "./helpers/action-event-states";

class PreferredPharmacySearchViewController extends PharmacySearchV2ViewController {
  handleButtonClick(name, text, action, ...[, , eventStates]) {
    if (eventStates?.length) {
      this.updateStates(eventStates, true);
      return;
    }

    // Keep using the default handler for the rest of the buttons.
    if (!searchButtons.includes(name)) {
      if (name === "manualPharmacy") {
        this.formState = { ...manualPharmacyFormState };
      }

      if (action?.value) {
        super.handleButtonClick(name, text, action);
      }

      return;
    }
    clearPreBuiltFields();

    const searchBy = name.includes(".")
      ? name.split(".")[0]
      : name.replace("MapSearchButton", "");
    switch (searchBy) {
      case "currentLocation":
      case "zipcode":
      case "city":
      case "citystate":
        this.appData.capsuleDeliverableCheck();
        break;
      default:
        super.handleButtonClick(name, text, action);
        break;
    }
  }

  preprocessScreenData() {
    const { values } = this.appData;

    (this.screen.conditionals || []).forEach(c => {
      const field = (c.fields || []).find(x => x.name === "state");

      if (field) {
        field.text = values.state;
      }

      const searchButton = (c.fields || []).find(x => x.title === "Continue");

      if (
        searchButton &&
        (c.value === "Zip Code" || c.value === "City/State")
      ) {
        searchButton.action.needsValidation = true;
      }
    });

    this.updateFieldsStatesOnItemSelect(values);
  }

  updateFieldsStatesOnItemSelect = values => {
    if (values.searchBy && values.searchBy !== "Recent Pharmacies") {
      const selectField = this.screen.fields.find(
        field => field.name === "searchBy"
      );

      if (selectField) {
        this.updateStates(
          getFieldActionEventStates(
            selectField,
            actionEventsMap.onItemSelectEvent
          ),
          false
        );
      }
    }
  };
}

export default PreferredPharmacySearchViewController;
